import React from 'react';
import { connect } from 'react-redux';

import {
  Row,
  Alert,
} from 'react-bootstrap';

class EnvironmentBanner extends React.Component {

  setProductionAlert = () => {

    let bsStyle, content;

    if (!this.props.web3.provider) {

      // Metamask not installed:
      return false;
    } else if (this.props.ethNetwork === 'Mainnet') {

      // Set Production announcements here:
      return false;
    } else {

      // Staging + Test Networks:
      bsStyle = 'warning';
      content = (<p>
        You are connected to {this.props.ethNetwork}. Please switch to Mainnet in Metamask.
      </p>);
    }

    return { bsStyle, content };
  }

  setDevelopmentAlert = () => {
    let bsStyle = 'warning';
    let content = (<div>
      <p>You are connected to {this.props.ethNetwork} in <strong>{process.env.NODE_ENV}</strong> mode.</p>
      <p>Current Block: {this.props.blockNumber}</p>
    </div>);

    return { bsStyle, content };
  }

  render() {

    let data;

    switch(process.env.NODE_ENV) {
      case 'development':
        data = this.setDevelopmentAlert();
        break;

      case 'production':
        data = this.setProductionAlert();

        if (!data) return <span></span>;
        break;

      default:
        break;
    }

    return (
      <Row>
        <Alert bsStyle={data.bsStyle}>
          {data.content}
        </Alert>
      </Row>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    blockNumber: state.web3.blockNumber,
    ethNetwork: state.web3.ethNetwork,
    web3: state.web3,
  };
};

export default connect(mapStateToProps)(EnvironmentBanner);



// WEBPACK FOOTER //
// ./src/components/EnvironmentBanner.js